import { Form, Select, Table, Button, Space, Tag, Input, Flex } from 'antd';
import { EditOutlined, DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import FilterCircular from './Filter/FilterCircular';

import WorkflowManagementAPI from '../../../restAPI/WorkflowManagementAPI';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';


export default function Archived({ tabValue, searchText, archivedDrawer, onChangeState  }) {
    //console.log(archivedDrawer)
    const tabKey = 2;
    const [payload, setPayload] = useState([]);
    const [isStateChanged, setIsStateChanged] = useState(false);
    //const navigate = useNavigate(); // Initialize the useNavigate hook
    const { companyId, token, userCompany } = useSelector(state => state.auth);
    const [isArchivedListLoading, setIsArchivedListLoading] = useState(false);

    const [tempArchivedData, setTempArchivedData] = useState([]);
    const [filterValues, setFilterValues] = useState([]);
    const [openFilter, setOpenFilter] = useState(false);

    const showFilterDrawer = () => {
        setOpenFilter(true);
    };

    const onCloseFilter = () => {
        setOpenFilter(false);
        onChangeState(false)
    };

    // const onChangeState = () => {
    //     return 'false'
    // }


    useEffect(() => {
        setIsArchivedListLoading(true);
        getApprovalRequestsData();
    }, [companyId, tabValue]);

    useEffect(() => {
        getApprovalRequestsData();
    }, [isStateChanged]);

    useEffect(() => {
        handleFilterSearchFunction(filterValues);
    }, [filterValues])

    useEffect(() => {
        handleSearchFunction(searchText)
    }, [searchText])

    const getApprovalRequestsData = async () => {
        await WorkflowManagementAPI.getApprovalRequests(tabKey, companyId, token).then((res) => {
            var dataList = res.data
            dataList.forEach(element => {
                let changeDate = new Date(element['createdAt']).toLocaleString()
                element['createdAt'] = changeDate
                element['initiator'] = element['createdBy']['name']
            });
            //console.log(dataList)
            setPayload(dataList)
            setTempArchivedData(dataList)
            setIsArchivedListLoading(false);
        }).catch((err) => {
            setIsArchivedListLoading(false);
        }).finally(() => {

        })
    };


    const columns = [
        {
            title: 'Circulated On',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text) => {
                const date = new Date(text);
                const dateString = date.toLocaleDateString(); 
                const timeString = date.toLocaleTimeString(); 
                return (
                    <span>
                        {dateString}
                        <br />
                        {timeString}
                    </span>
                );
            },
        },
        {
            title: 'Initiator',
            dataIndex: ['createdBy', 'name'],
            key: 'initiator',
        },
        {
            title: 'Subject Line',
            dataIndex: 'subject',
            key: 'subject',
        },
        {
            title: 'Request Type',
            dataIndex: ['requestType', 'requestType'],
            //key: 'requestType',
        },
        {
            title: 'Previous Status',
            key: 'status',
            render: (_, record) => (
                <Space size="middle">
                    <Tag color="success"> Approved </Tag>
                    {/* <Tag color="error"> Reject </Tag> */}
                </Space>
            ),
        },
        {
            title: 'Action',
            key: 'actionButtons',
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    <Button onClick={() => onClickUnArchiveButton(record._id)} icon={<InboxOutlined />} type="text" title='Un-Archive' />
                </Space>
            ),
        },
    ];

    const onClickUnArchiveButton = async (data) => {
        //console.log(data)
        setIsStateChanged(false)

        var formData = {
            "action": "unarchive"
        }
        await WorkflowManagementAPI.setArchiveUnarchive(data, formData, companyId, token).then((res) => {
            setIsStateChanged(true)
        })
    }

    const handleFilterDetailsChange = (value) => {
        setFilterValues(value);
    }
    
    const handleSearchFunction = (value) => {
        if (value) {
            if (filterValues.length > 0) {
                console.log('hi 1')
                const filteredData = payload.filter(item =>
                    item.status.toLowerCase().includes(value.toLowerCase()) ||
                    item.initiator.toLowerCase().includes(value.toLowerCase()) ||
                    //item.createdAt.toLowerCase().includes(value.toString()) ||
                    item.circulationType.toLowerCase().includes(value.toLowerCase())
                );
                setTempArchivedData(filteredData);
            } else {
                console.log('hi 2')
                const filteredData = payload.filter(item =>
                    item.status.toLowerCase().includes(value.toLowerCase()) ||
                    item.initiator.toLowerCase().includes(value.toLowerCase()) ||
                    //item.createdAt.toLowerCase().includes(value.toString()) ||
                    item.circulationType.toLowerCase().includes(value.toLowerCase())
                );
                setTempArchivedData(filteredData);
            }
        } else {
            if (filterValues.length > 0) {
                const filterData = filterDataByCriteria(payload, filterValues);
                setTempArchivedData(filterData);
            } else {
                setTempArchivedData(payload)
            }
        }
    }

    const handleFilterSearchFunction = (value) => {
        //console.log(value)
        if (value) {
            if (searchText?.length > 0) {
                console.log('hi 3')
                const filteredData = payload.filter(item =>
                    item.status.toLowerCase().includes(searchText.toLowerCase()) ||
                    item.initiator.toLowerCase().includes(searchText.toLowerCase()) ||
                    //item.createdAt.toLowerCase().includes(value.toString()) ||
                    item.circulationType.toLowerCase().includes(searchText.toLowerCase()) 
                );
                const filterData2 = filterDataByCriteria(filteredData, value);
                setTempArchivedData(filterData2);
            } else {
                const filterData = filterDataByCriteria(payload, value);
                setTempArchivedData(filterData);
            }
        } else {
            if (searchText?.length > 0) {
                console.log('hi 4')
                const filteredData = payload.filter(item =>
                    item.status.toLowerCase().includes(searchText.toLowerCase()) ||
                    item.initiator.toLowerCase().includes(searchText.toLowerCase()) ||
                    //item.createdAt.toLowerCase().includes(value.toString()) ||
                    item.circulationType.toLowerCase().includes(searchText.toLowerCase()) 
                );
                setTempArchivedData(filteredData);
            } else {
                setTempArchivedData(payload);
            }
        }
    }

    const filterDataByCriteria = (data, criteria) => {
        return data.filter(item => {
            return criteria.every(({ key, value }) => {
                if (!item[key] || !value) return false;

                if (key == 'createdAt') {
                    const date = new Date(value).toLocaleString()
                    const itemValue = item[key].split(", ")[0];
                    const lowerCasePrefix = date.split(", ")[0];
                    return itemValue.startsWith(lowerCasePrefix);

                } else {
                    const itemValue = item[key].toString().toLowerCase();
                    const lowerCasePrefix = value.toLowerCase();
                    return itemValue.startsWith(lowerCasePrefix);
                }
            });
        });
    };

    const handleRemoveTag = (key) => {
        setFilterValues(prev =>
            prev.filter(item => item.key !== key)
        );
    }

    return (
        <>
            <>{
                isArchivedListLoading ? (<>
                    <CommonSkeletonLoader itemCount={2} />
                </>) : (<>
                    <div style={{ margin: '16px' }}>
                        {
                            filterValues.length !== 0 &&
                            <Flex align='center' gap={12}>
                                {filterValues.map(item => (
                                    <Tag
                                        bordered={false}
                                        closable
                                        color="success"
                                        key={item?.key}
                                        onClose={() => handleRemoveTag(item?.key)}
                                    >
                                        {item?.value}
                                    </Tag>
                                ))}
                            </Flex>
                        }
                    </div>
                    {/* <Table dataSource={payload} columns={columns} pagination={false} /> */}
                    <Table dataSource={tempArchivedData} columns={columns} pagination={false} />
                </>)
            }</>

            <>
                <FilterCircular
                    openDrawer={archivedDrawer}
                    closeDrawer={onCloseFilter}
                    data={tempArchivedData}
                    handleFilterDetailsChange={handleFilterDetailsChange}
                    filterValues={filterValues}
                    screenName="archivedData"
                />
            </>
        </>
    );
}
